module.exports = __webpack_public_path__ + "static/img/2_3.5eed8683.jpg";